export const AI_NOTIFICATION_MESSAGES: {
  [key: string]: { loading?: string; success: string; error: string }
} = {
  generateWireframe: {
    loading: 'Generating wireframe...',
    success: 'Wireframe generated.',
    error: 'Something went wrong.',
  },
  generateNewSection: {
    loading: 'Generating new section...',
    success: 'New section generated.',
    error: 'Failed to generate new section.',
  },
  replaceText: {
    loading: 'Replacing text...',
    success: 'Text replaced.',
    error: 'Failed to replace text.',
  },
  checkSpelling: {
    loading: 'Checking spelling...',
    success: 'Spelling checked and corrected.',
    error: 'Failed to check spelling.',
  },
  rewriteText: {
    loading: 'Rewriting...',
    success: 'Text rewritten.',
    error: 'Failed to rewrite text.',
  },
  regenerate: {
    loading: 'Regenerating...',
    success: 'Content regenerated.',
    error: 'Failed to regenerate content.',
  },
  changeTone: {
    loading: 'Adjusting tone...',
    success: 'Tone adjusted.',
    error: 'Failed to adjust tone.',
  },
  makeShorter: {
    loading: 'Adjusting length...',
    success: 'Text shortened.',
    error: 'Failed to shorten text.',
  },
  makeLonger: {
    loading: 'Adjusting length...',
    success: 'Text expanded.',
    error: 'Failed to lengthen text.',
  },
  generateImage: {
    loading: 'Generating image...',
    success: 'Image generated.',
    error: 'Failed to generate image.',
  },
  replaceImages: {
    loading: 'Replacing images...',
    success: 'Images replaced.',
    error: 'Failed to replace images.',
  },
}
